import { apiClient } from '../../core/apiClient';
import { createResourcesHooks } from './resource.hooks';
import { createResourcesApi } from './resource.http';

export const myResources = createResourcesHooks(
  createResourcesApi(apiClient, true)
);
